import { useQuery } from '@apollo/client';
import { GET_STORE } from '@/query';

const useStore = () => {
  const result = useQuery(GET_STORE);
  return { store: result.data?.store, ...result };
};

export default useStore;
